import './public-path';
import { hydrateRoot } from 'react-dom/client';
import { createElement } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from './components/App';
import { routes } from './components/routes';

import { getContextFromWindow } from './components/context';

const { matchedRouteIndex = 0 } = getContextFromWindow().state || {};

routes[matchedRouteIndex].PageComponent.preload().finally(() => {
  hydrateRoot(document.getElementById('app'), createElement(Router, {}, createElement(App, {})));
});
